import { spaceModel } from 'APP/model/model';
import { ISpaceParticipantsChange } from 'APP/model/space/spaceModel.types';
import { spaceAnalytics } from 'APP/packages/analytics/analytics';

export async function promoteAdminToSpace(data: ISpaceParticipantsChange): Promise<boolean> {
  try {
    await spaceModel.promoteToAdmin(data);

    data.userIds.forEach((userId) => spaceAnalytics.trackSpaceAdminAdded(data.spaceId, userId));

    return true;
  } catch {
    return false;
  }
}
